import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { Service } from '@mews-commander/data-access';
import { Divider, Highlight } from '@optimus-web/core';
import { FormSwitchField, LocalizedProperty } from '@mews/framework';
import { isBookableService as getIsBookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';
import { RoutingRulesFormStepName } from '../../../../../types';
import { RoutingRulesFormFields } from '../../../utils';
import { ItemsServiceOptionsField } from './ItemsServiceOptionsField';
import { DEFAULT_ENABLED_ADDITIONAL_SERVICE_OPTIONS, DEFAULT_ENABLED_SERVICE_OPTIONS } from './constants';

export const ItemsServiceForm = ({
    service,
    index,
    isOneService,
}: {
    service: Service;
    index: number;
    isOneService: boolean;
}) => {
    const { watch, trigger, setValue, getValues } = useFormContext();

    const handleToggleChange = async () => {
        await trigger();
    };

    const isBookableService = getIsBookableService(service);

    const enableServiceField = isBookableService
        ? RoutingRulesFormFields.serviceEnabled(service.id)
        : RoutingRulesFormFields.additionalServiceEnabled(service.id);

    const isServiceEnabled = watch(enableServiceField);
    const formValues = getValues(RoutingRulesFormStepName.ItemsAndConditions);
    const isOneBookableService = isOneService && isBookableService;

    useEffect(() => {
        if (isOneBookableService) {
            setValue(enableServiceField, true);
        }
    }, [isOneBookableService, setValue, enableServiceField]);

    useEffect(() => {
        if (isBookableService) {
            setValue(
                RoutingRulesFormFields.serviceOptions(service.id),
                formValues?.services[service.id]?.serviceOptions || DEFAULT_ENABLED_SERVICE_OPTIONS
            );
        } else {
            setValue(
                RoutingRulesFormFields.additionalServiceOptions(service.id),
                formValues?.additionalServices[service.id]?.serviceOptions || DEFAULT_ENABLED_ADDITIONAL_SERVICE_OPTIONS
            );
        }
    }, [setValue, service.id, formValues, isBookableService]);

    const additionalFields = <ItemsServiceOptionsField service={service} isBookableService={isBookableService} />;

    return isOneBookableService ? (
        <>
            <Highlight size="small">
                <LocalizedProperty property={service.names} />
            </Highlight>
            {additionalFields}
        </>
    ) : (
        <>
            {index === 0 ? null : <Divider />}
            <FormSwitchField
                name={enableServiceField}
                onChange={handleToggleChange}
                label={
                    <Highlight size="small">
                        <LocalizedProperty property={service.names} />
                    </Highlight>
                }
            />
            {isServiceEnabled ? additionalFields : null}
        </>
    );
};
